import {
    Button,
    chakra,
    Flex,
    Heading,
    Text
} from '@chakra-ui/react';

import { PagePadding } from '../../../style/constants';

export const APP_HEADING_HEIGHT = '56px';

export const container = chakra(Flex, {
    label: 'app-heading-container',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'space-between',
        marginLeft: PagePadding.left,
        marginRight: PagePadding.right,
        h: APP_HEADING_HEIGHT
    }
});

export const heading = chakra(Heading, {
    label: 'app-heading-heading',
    baseStyle: {
        alignItems: 'baseline',
        color: 'primary.900',
        display: 'flex',
        fontWeight: 400,
        fontSize: '24px',
        lineHeight: '140%',
        letterSpacing: '-0.4px',
        gap: '6px'
    }
});

export const headingContext = chakra(Text, {
    label: 'app-heading-heading-context',
    baseStyle: {
        color: 'primary.900',
        fontSize: '18px',
        fontWeight: 400,
        letterSpacing: 0,
        lineHeight: '130%'
    }
});

export const exportButton = chakra(Button, {
    label: 'app-heading-export-button',
    baseStyle: {
        w: 'auto',
        minWidth: 'auto',
        p: '0 12px !important',
        fontSize: '12px !important',
        fontWeight: 500,
        h: '32px'
    }
});

export const navigationButton = chakra(Button, {
    label: 'app-heading-navigation-button',
    baseStyle: {
        h: '32px'
    }
});

export const helpContainer = chakra(Flex, {
    label: 'help-container',
    baseStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        fill: 'white.0',
        w: '32px',
        h: '32px',
        backgroundColor: 'white.0',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'primary.300',
        cursor: 'pointer'
    }
});
